export default {
	updateFuelHeader: [
		{
			settings: true,
			text: "Tran date",
			value: "filter_trandate",
			func: false,
			filterable: false,
			sortable: true,
			model: { value: 'date', },
			left: false,
			dense: true
		},
		{
			settings: true,
			text: "Amt",
			value: "filter_amt",
			func: false,
			filterable: false,
			sortable: true,
			model: { value: 'number', },
			left: false,
			dense: true
		},
		{
			settings: true,
			text: "Card",
			value: "filter_card",
			func: false,
			filterable: false,
			sortable: true,
			model: { value: 'list', },
			left: false,
			dense: true
		},
		{
			settings: true,
			text: "Invoice",
			value: "filter_invoice",
			func: false,
			filterable: false,
			sortable: true,
			model: { value: 'list', },
			left: false,
			dense: true
		},
		{
			settings: true,
			text: "Unit",
			value: "filter_unit",
			func: false,
			filterable: false,
			sortable: true,
			model: { value: 'list', },
			left: false,
			dense: true
		},
		{
			settings: true,
			text: "Driver name",
			value: "filter_drivername",
			func: false,
			filterable: false,
			sortable: true,
			model: { value: 'number', },
			left: false,
			dense: true
		},
		{
			settings: true,
			text: "Odometer",
			value: "filter_odometer",
			func: false,
			filterable: false,
			sortable: true,
			model: { value: 'list', },
			left: false,
			dense: true
		},
		{
			settings: true,
			text: "Location name",
			value: "filter_locationname",
			func: false,
			filterable: false,
			sortable: true,
			model: { value: 'list', },
			left: false,
			dense: true
		},
		{
			settings: true,
			text: "City",
			value: "filter_city",
			func: false,
			filterable: false,
			sortable: true,
			model: { value: 'list', },
			left: false,
			dense: true
		},
		{
			settings: true,
			text: "state/prov",
			value: "filter_stateprov",
			func: false,
			filterable: false,
			sortable: true,
			model: { value: 'list', },
			left: false,
			dense: true
		},
		{
			settings: true,
			text: "Fees",
			value: "filter_fees",
			func: false,
			filterable: false,
			sortable: true,
			model: { value: 'list', },
			left: false,
			dense: true
		},
		{
			settings: true,
			text: "Item",
			value: "filter_item",
			func: false,
			filterable: false,
			sortable: true,
			model: { value: 'list', },
			left: false,
			dense: true
		},
		{
			settings: true,
			text: "Unit price",
			value: "filter_unitprice",
			func: false,
			filterable: false,
			sortable: true,
			model: { value: 'list', },
			left: false,
			dense: true
		},
		{
			settings: true,
			text: "Disc ppu",
			value: "filter_discppu",
			func: false,
			filterable: false,
			sortable: true,
			model: { value: 'number', },
			left: false,
			dense: true
		},
		{
			settings: true,
			text: "Disc cost",
			value: "filter_disccost",
			func: false,
			filterable: false,
			sortable: true,
			model: { value: 'number', },
			left: false,
			dense: true
		},
		{
			settings: true,
			text: "Qty",
			value: "filter_qty",
			func: false,
			filterable: false,
			sortable: true,
			model: { value: 'number', },
			left: false,
			dense: true
		},
		{
			settings: true,
			text: "Disc amt",
			value: "filter_discamt",
			func: false,
			filterable: false,
			sortable: true,
			model: { value: 'number', },
			left: false,
			dense: true
		},
		{
			settings: true,
			text: "Disc type",
			value: "filter_disctype",
			func: false,
			filterable: false,
			sortable: true,
			model: { value: 'number', },
			left: false,
			dense: true
		},
		{
			settings: true,
			text: "Db",
			value: "filter_db",
			func: false,
			filterable: false,
			sortable: true,
			model: { value: 'list', },
			left: false,
			dense: true
		},
		{
			settings: true,
			text: "Currency",
			value: "filter_currency",
			func: false,
			filterable: false,
			sortable: true,
			model: { value: 'list', },
			left: false,
			dense: true
		},
	],
	updateClientsHeader: [
		{
			settings: true,
			text: "Mc",
			value: "mc",
			func: false,
			filterable: false,
			model: { value: 'list', },
			sortable: true,
			left: false,
			dense: true
		},
		{
			settings: true,
			text: "Phone",
			value: "phone",
			func: false,
			filterable: false,
			sortable: true,
			model: { value: 'list', },
			left: false,
			dense: true
		},
		{
			settings: true,
			text: "Truks qty",
			value: "truksqty",
			func: false,
			filterable: false,
			sortable: true,
			model: { value: 'list', },
			left: false,
			dense: true
		},
		{
			settings: true,
			text: "Email",
			value: "email",
			func: false,
			filterable: false,
			sortable: true,
			model: { value: 'list', },
			left: false,
			dense: true
		},
		{
			settings: true,
			text: "Contact name",
			value: "contactname",
			func: false,
			filterable: false,
			sortable: true,
			model: { value: 'list', },
			left: false,
			dense: true
		},
		{
			settings: true,
			text: "Carrier name",
			value: "carriername",
			func: false,
			filterable: false,
			sortable: true,
			model: { value: 'number', },
			left: false,
			dense: true
		},
		{
			settings: true,
			text: "Aubrey comment",
			value: "aubreycomment",
			func: false,
			filterable: false,
			sortable: true,
			model: { value: 'list', },
			left: false,
			dense: true
		},
		{
			settings: true,
			text: "Error",
			value: "error",
			func: false,
			filterable: false,
			sortable: true,
			model: { value: 'list', },
			left: false,
			dense: true
		},
	]
};

